export const SET_STATUS="app/citizens/SET_STATUS"
export const NEXT_PAGE="app/citizens/NEXT_PAGE"
export const BACK_PAGE="app/citizens/BACK_PAGE"
export const RESET_PAGE="app/citizens/RESET_PAGE"
export const CITIZENS_LOADING="app/citizens/OPERATORS_LOADING"
export const SET_SEARCH="app/citizens/SET_SEARCH"
export const SET_SEARCH_VIEW="app/citizens/SET_SEARCH_VIEW"
